import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Homepage from './pages/homepage';
import Builder from './pages/builder';
import Donate from './pages/donate';
import PageNotFound from './pages/404';
import Auth from './pages/auth';
import Dashboard from './pages/dashboard';
import ActivateAccount from './pages/activate-account';
import { AnimatePresence } from 'framer-motion';

const Content = () => {
    const purple_bk = "row purple-bk rounded-3 p-3";
    const white_bk = "row dashboard rounded-3 p-3";

    return (
        <AnimatePresence>
            <div className="container content mt-5">
                    <Routes>
                        <Route path="builder/pokeland" element={<Homepage classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/builds/:pokemon_name" element={<Homepage classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/dashboard" element={<Dashboard classes={white_bk}/>}></Route>
                        <Route path="builder/pokeland/auth" element={<Auth classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/new-build" element={<Builder classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/dashboard/build/edit/:editingID" element={<Builder classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/build/:viewingID" element={<Builder classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/donate" element={<Donate classes={purple_bk}/>}></Route>
                        <Route path="builder/pokeland/activate-account" element={<ActivateAccount classes={purple_bk}/>}></Route>
                        <Route path="*" element={<PageNotFound classes={purple_bk}/>} />
                        <Route path="builder/pokeland/404" element={<PageNotFound classes={purple_bk}/>} />
                    </Routes>
            </div>
        </AnimatePresence>
    );
}
export default Content;